module.exports = __webpack_public_path__ + "static/img/redegg.bded68a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/redegg.png
// module id = /vaH
// module chunks = 1